import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { captureVisit } from './lib/attribution';
import { startInstallListener } from './lib/platform/install';

// The browser can offer its install prompt before the app has finished loading.
startInstallListener();
// Where this visitor came from (campaign tags, referring site), for the admin Engagement page.
void captureVisit();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
